export default __webpack_public_path__ + "static/media/index_1.62760cfc.png";